import { sharedData } from "../Data/sharedData";

export const footerMenu = [
	{
		title: "فروشگاه دیجی‌کالا",
		link: "https://www.digikala.com/" + sharedData.utmParams,
	},
	{
		title: "مارکت‌پلیس دیجی‌کالا",
		link: "https://selleracademy.digikala.com/" + sharedData.utmParams,
	},
	{
		title: "بیانیه‌های مطبوعاتی",
		link: "/newsroom/?cat=401#newsCategories",
	},
	{
		title: "اتاق خبر دیجی‌کالا",
		link: "/newsroom/",
	},
	{
		title: "پلتفرم ویدیو",
		link: "https://about.digikala.com/videos/" + sharedData.utmParams,
	},
	{
		title: "گزارش‌ سال دیجی‌کالا",
		link:
			"https://about.digikala.com/reports/digikala1404/" + sharedData.utmParams,
	},
	{
		title: "فرصت‌های همکاری",
		link: "https://careers.digikala.com/" + sharedData.utmParams,
	},
	{
		title: "مسئولیت ما",
		link: "https://about.digikala.com/digikalamehr/" + sharedData.utmParams,
	},
	{
		title: "پاسخ به پرسش‌های متداول",
		link: "https://www.digikala.com/faq/" + sharedData.utmParams,
	},
];
